import * as T from '^/types';

export const sortPhotoAlbums = (photoAlbums: T.PhotoAlbum[]) => {
  if (!photoAlbums) {
    return [];
  }
  return photoAlbums.sort((a, b) => {
    if (!a.requestedAt && !b.requestedAt) {
      return 0;
    }
    if (!a.requestedAt) {
      return -1;
    }
    if (!b.requestedAt) {
      return 1;
    }
    const aDate = new Date(a.requestedAt).getTime();
    const bDate = new Date(b.requestedAt).getTime();
    return bDate - aDate;
  });
};
